import { render, staticRenderFns } from "./orgRole.vue?vue&type=template&id=cdd56606&scoped=true&"
import script from "./orgRole.vue?vue&type=script&lang=js&"
export * from "./orgRole.vue?vue&type=script&lang=js&"
import style0 from "./orgRole.vue?vue&type=style&index=0&id=cdd56606&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd56606",
  null
  
)

export default component.exports